import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Modal de advertencia que se muestra 30 segundos antes del cierre de sesión por inactividad
 *
 * @param {Object} props
 * @param {boolean} props.show - Si debe mostrarse el modal
 * @param {number} props.remainingSeconds - Segundos restantes para el cierre
 */
export default function InactivityWarning({ show, remainingSeconds }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 animate-fade-in">
      <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md w-full mx-4 animate-scale-in">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
            <AlertCircle className="text-orange-600" size={24} />
          </div>

          <div className="flex-1">
            <h3 className="text-lg font-semibold text-ink-900 mb-2">
              Sesión por Expirar
            </h3>
            <p className="text-ink-600 mb-1">
              Tu sesión se cerrará en <span className="font-bold text-orange-600">{remainingSeconds} segundos</span> por inactividad.
            </p>
            <p className="text-sm text-ink-500">
              Mueve el mouse para continuar tu sesión.
            </p>

            {/* Barra de progreso */}
            <div className="mt-4 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-orange-500 transition-all duration-1000 ease-linear"
                style={{ width: `${(remainingSeconds / 60) * 100}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
